export let texts = [
    {
        "id": "support",
        "name":"Support",
        "title": "Support",
        "css": "MatcHelpTopicSpacer",
        "body": `
            If you need help with Quant-UX, please use our channel at
            <a class="MatcHelpLink" target="quxSpectrumChat" href="https://discord.gg/TQBpfAAKmU">Discord.com</a>
            or contact us directly.
        `,
    }
]